import type { User } from "$types";
export const generate_notification_query = (
  user?: User,
  full_set: boolean = true,
) => {
  if (!user) return;
  let limit: {
    limit: number;
    offset?: number;
  } = {
    limit: 5,
  };

  if (!full_set) {
    limit = {
      limit: 1,
      offset: 4,
    };
  }

  return {
    fields: [
      "id",
      "seen_by",
      "date_created",
      "actor",
      "audience",
      "seen_by.user.id",
      "min_required_support",
      "link",
      "title",
      "item.collection",
    ],
    sort: ["date_created"],
    ...limit,
    filter: {
      _and: [
        {
          seen_by: {
            _none: {
              user: {
                _eq: user.id,
              },
            },
          },
        },
        {
          item: {
            _nnull: true,
          },
        },
        {
          min_required_support: {
            _lte: user.support_level,
          },
        },
        {
          _or: [
            {
              audience: {
                id: { _eq: user.id },
              },
            },
            {
              audience: {
                _null: true,
              },
            },
          ],
        },
      ],
    },
  };
};
